import { Component, OnInit } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { DipDetectionService } from './dipdetection.service';
import { DipDetection } from './dipdetection';
import { DipDetectionList } from './dipdetectionList';
import { ToasterService } from 'angular2-toaster/src/toaster.service';
import {current} from 'codelyzer/util/syntaxKind';



@Component({
    templateUrl: 'dipdetection.component.html',
    styleUrls: ['dipdetection.component.scss']
})
export class DipDetectionComponent implements OnInit {

    wikipediaDipDetections: DipDetectionList[];
    bittorentDipDetections: DipDetectionList[];
    facebookDipDetections: DipDetectionList[];
    instagramDipDetections: DipDetectionList[];
    tumblrDipDetection: DipDetectionList[];
    dailymotionDipDetection: DipDetectionList[];
    youtubeDipDetection: DipDetectionList[];
    twitterDipDetection: DipDetectionList[];



    selectedSourceList: DipDetectionList[];
    selectedDetectionList: DipDetection[];

    loading = true;
    dipDetection: DipDetection;
    notificationTitle: any;
    notificationContent: any;
    notificationType: any;
    submitting = false;
    disabled = false;
    statusViewType = 'View All';
    sortType = 'Adjusted Value';
    sortTypeTwo = 'Adjusted Value';

    dateRange = 1;
    date1: Date;
    status = false;
    source = 'facebook';
    step = 'one';
    formattedDate: any;
    selectedTitle = '*Not Selected*';
    selectedContentType = undefined;
    anomalytype = 'dip';

    currentDate: any;

    private checkboxes = {
        show: true,
        movie: true,
        talent: true,
        client_ready: true,
        demand_generation: true
    };


    constructor(private toasterService: ToasterService,
        private dipDetectionService: DipDetectionService) { }

    getFilterList() {
        const filterList = [];

        if (this.checkboxes.talent) {
            filterList.push('TALENT');
        }

        if (this.checkboxes.movie) {
            filterList.push('MOVIE');
        }

        if (this.checkboxes.show) {
            filterList.push('SHOW');
        }

        if (this.checkboxes.client_ready) {
            filterList.push('client_ready');
        }

        if (this.checkboxes.demand_generation) {
            filterList.push('demand_generation');
        }

        return filterList;
    }

    getFilteredResultSet(dataSourceResult, filterList) {
        let filteretedDataSourceResult = dataSourceResult;
        if (dataSourceResult) {

            filteretedDataSourceResult = filteretedDataSourceResult.filter(result => {
                return (result.content_type && filterList.includes(result.content_type));
            });
            filteretedDataSourceResult = filteretedDataSourceResult.filter(result => {
                return (result.catalog_state && filterList.includes(result.catalog_state));
            });

            return filteretedDataSourceResult;


        }

        return filteretedDataSourceResult;

    }

    getDipDetection(dateFrom: string, dateTo: string, type: string) {
        const filterList = this.getFilterList();
        this.submitting = true;
        this.dipDetectionService.getDipDetection(dateFrom, dateTo, type)
            .then(res => {
                // this.wikipediaDipDetections = getFilteredResult(res.result.wikipedia);
                this.wikipediaDipDetections = this.getFilteredResultSet(res.result.wikipedia, filterList);
                this.bittorentDipDetections = this.getFilteredResultSet(res.result.bittorrent, filterList);
                this.facebookDipDetections = this.getFilteredResultSet(res.result.facebook, filterList);
                this.instagramDipDetections = this.getFilteredResultSet(res.result.instagram_v2, filterList);
                this.dailymotionDipDetection = this.getFilteredResultSet(res.result.dailymotion, filterList);
                this.tumblrDipDetection = this.getFilteredResultSet(res.result.tumblr_v2, filterList);
                this.twitterDipDetection = this.getFilteredResultSet(res.result.twitter, filterList);
                this.youtubeDipDetection = this.getFilteredResultSet(res.result.youtube, filterList);

                this.clickSource(this.source);
                this.clickSortType(event);
                this.status = true;
                this.loading = false;
            })
            .catch(error => {
                this.errorHandler(error);
            });

    }

    ngOnInit() {
        {
            const date = new Date();
            if (date.getHours() < 10 || date.getHours() > 18) {
                this.disabled = false;
            }
            date.setDate(date.getDate() - 1);
            this.formattedDate = this.dateFormatter(date);
            this.getDipDetection(this.dateFormatter(date), this.dateFormatter(date), this.anomalytype
            );
        }
    }


    // tslint:disable-next-line:member-ordering
    public options = {
        timeOut: 2000,
        lastOnBottom: true,
        clickToClose: true,
        maxLength: 0,
        maxStack: 2,
        showProgressBar: true,
        pauseOnHover: true,
        preventDuplicates: false,
        preventLastDuplicates: 'visible',
        rtl: false,
        animate: 'scale',
        position: ['right', 'bottom']
    };

    createNotification() {
        switch (this.notificationType) {
            case 'success':
                // tslint:disable-next-line:comment-format
                //this._service.success(this.notificationTitle, this.notificationContent);
                this.toasterService.pop('success', this.notificationTitle, this.notificationContent);
                break;
            case 'error':
                this.toasterService.pop('error', this.notificationTitle, this.notificationContent);
                // tslint:disable-next-line:comment-format
                //this._service.error(this.notificationTitle, this.notificationContent);
                break;
            case 'info':
                this.toasterService.pop('info', this.notificationTitle, this.notificationContent);
                // tslint:disable-next-line:comment-format
                //this._service.info(this.notificationTitle, this.notificationContent);
                break;
        }
    }

    createDateWithIntervalFromNow(range: number) {
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate() - range);
        return this.dateFormatter(currentDate);
    }

    clickDateRange(range: number) {
        event.stopPropagation();
        this.loading = true;
        this.wikipediaDipDetections = undefined;
        this.bittorentDipDetections = undefined;
        this.facebookDipDetections = undefined;
        this.instagramDipDetections = undefined;
        this.tumblrDipDetection = undefined;
        this.dailymotionDipDetection = undefined;
        this.youtubeDipDetection = undefined;
        this.twitterDipDetection = undefined;



        this.status = false;
        this.dateRange = range;
        this.currentDate = new Date();
        this.currentDate.setDate(this.currentDate.getDate() - range);
        this.formattedDate = this.dateFormatter(this.currentDate);
        this.getDipDetection(this.dateFormatter(this.currentDate), this.dateFormatter(this.currentDate), this.anomalytype);
    }

    errorHandler(error: any) {
        this.submitting = false;
        this.notificationType = 'error';
        this.notificationTitle = 'Error';
        this.notificationContent = error;
        this.createNotification();
    }

    dateFormatter(dateInput: Date) {
        const rawmonth = dateInput.getUTCMonth() + 1;
        const rawday = dateInput.getUTCDate();
        let month = rawmonth.toString();
        if (month.length === 1) {
            month = '0' + month;
        }
        let day = rawday.toString();
        if (day.length === 1) {
            day = '0' + day;
        }
        const year = dateInput.getUTCFullYear().toString();
        const formattedDate = year + '-' + month + '-' + day;
        return formattedDate;
    }

    getOriginalValue(title: DipDetectionList) {
        let orgValue = 0;
        title.detections.forEach(t => orgValue += t.original_value);
        return Math.round(orgValue);
    }

    getAdjustedValue(title: DipDetectionList) {
        let adjValue = 0;
        title.detections.forEach(t => t.status === 'accepted' || t.status === 'override' ? adjValue += t.adjusted_value : adjValue += 0);
        return Math.round(adjValue);
    }


    getFinalValue(title: DipDetectionList) {
        let adjValue = 0;
        let orjValue = 0;

        title.detections.forEach(t => t.status === 'accepted' || t.status === 'override' ? adjValue += t.adjusted_value : adjValue += 0);
        title.detections.forEach(t => t.status === 'rejected' ? orjValue += t.original_value : orjValue += 0);

        const sumValue = adjValue + orjValue;

        return Math.round(sumValue);
    }



    clickSource(source: any) {
        this.source = source;
        if (source === 'facebook') {
            this.selectedSourceList = this.facebookDipDetections;
        } else if (source === 'instagram') {
            this.selectedSourceList = this.instagramDipDetections;
        } else if (source === 'bittorrent') {
            this.selectedSourceList = this.bittorentDipDetections;
        } else if (source === 'wikipedia') {
            this.selectedSourceList = this.wikipediaDipDetections;
        } else if (source === 'tumblr') {
            this.selectedSourceList = this.tumblrDipDetection;
        } else if (source === 'dailymotion') {
            this.selectedSourceList = this.dailymotionDipDetection;
        } else if (source === 'twitter') {
            this.selectedSourceList = this.twitterDipDetection;
        } else if (source === 'youtube') {
            this.selectedSourceList = this.youtubeDipDetection;
        }

        this.clickStep('one');
        this.selectedTitle = '*Not Selected*';
        this.selectedDetectionList = undefined;
        this.clickSortType(event);
    }


    clickStep(step: any) {
        this.step = step;
        if (step === 'one') {
            this.selectedTitle = '*Not Selected*';
            this.selectedDetectionList = undefined;
        }
    }
    clickSortType(event: any) {
        if (this.selectedSourceList !== undefined && this.selectedSourceList.length > 0) {

            if (this.sortType === 'Title') {
                this.selectedSourceList.sort((leftSide, rightSide): number => {
                    if (leftSide.title_name > rightSide.title_name) { return 1; };
                    if (leftSide.title_name < rightSide.title_name) { return -1; };
                    return 0;
                });
            } else if (this.sortType === 'Adjusted Value') {
                this.selectedSourceList.sort((leftSide, rightSide): number => {
                    if (this.getAdjustedValue(leftSide) < this.getAdjustedValue(rightSide)) { return 1; };
                    if (this.getAdjustedValue(leftSide) > this.getAdjustedValue(rightSide)) { return -1; };
                    return 0;
                });
            } else if (this.sortType === 'Original Value') {
                this.selectedSourceList.sort((leftSide, rightSide): number => {
                    if (this.getOriginalValue(leftSide) < this.getOriginalValue(rightSide)) { return 1; };
                    if (this.getOriginalValue(leftSide) > this.getOriginalValue(rightSide)) { return -1; };
                    return 0;
                });
            } else if (this.sortType === 'Release Date') {
                this.selectedSourceList.sort((leftSide, rightSide): number => {
                    if (new Date(leftSide.release_date) < new Date(rightSide.release_date)) { return 1; };
                    if (new Date(leftSide.release_date) > new Date(rightSide.release_date)) { return -1; };
                    return 0;
                });
            }
        }
    }


    clickSortTypeStepTwo(event: any) {
        if (this.selectedDetectionList !== undefined && this.selectedDetectionList.length > 0) {
            if (this.sortTypeTwo === 'Language') {
                this.selectedDetectionList.sort((leftSide, rightSide): number => {
                    if (leftSide.language > rightSide.language) { return 1; };
                    if (leftSide.language < rightSide.language) { return -1; };
                    return 0;
                });
            } else if (this.sortTypeTwo === 'Adjusted Value') {
                this.selectedDetectionList.sort((leftSide, rightSide): number => {
                    if (leftSide.adjusted_value < rightSide.adjusted_value) { return 1; };
                    if (leftSide.adjusted_value > rightSide.adjusted_value) { return -1; };
                    return 0;
                });
            } else if (this.sortTypeTwo === 'Original Value') {
                this.selectedDetectionList.sort((leftSide, rightSide): number => {
                    if (leftSide.original_value < rightSide.original_value) { return 1; };
                    if (leftSide.original_value > rightSide.original_value) { return -1; };
                    return 0;
                });
            } else if (this.sortTypeTwo === 'Type') {
                this.selectedDetectionList.sort((leftSide, rightSide): number => {
                    if (leftSide.source_event_type < rightSide.source_event_type) { return 1; };
                    if (leftSide.source_event_type > rightSide.source_event_type) { return -1; };
                    return 0;
                });
            } else if (this.sortTypeTwo === 'Item') {
                this.selectedDetectionList.sort((leftSide, rightSide): number => {
                    if (leftSide.source_event_item < rightSide.source_event_item) { return 1; };
                    if (leftSide.source_event_item > rightSide.source_event_item) { return -1; };
                    return 0;
                });
            } else if (this.sortTypeTwo === 'Country') {
                this.selectedDetectionList.sort((leftSide, rightSide): number => {
                    if (leftSide.country < rightSide.country) { return 1; };
                    if (leftSide.country > rightSide.country) { return -1; };
                    return 0;
                });
            } else if (this.sortTypeTwo === 'Status') {
                this.selectedDetectionList.sort((leftSide, rightSide): number => {
                    if (leftSide.status < rightSide.status) { return 1; };
                    if (leftSide.status > rightSide.status) { return -1; };
                    return 0;
                });
            }
        }
    }

    getRejectedValue(title: DipDetectionList) {
        let value = 0;
        title.detections.forEach(x => x.status === 'rejected' ? value++ : 0);
        return value;
    }
    getAcceptedValue(title: DipDetectionList) {
        let value = 0;
        title.detections.forEach(x => x.status === 'accepted' ? value++ : 0);
        return value;
    }

    getOvverrideValue(title: DipDetectionList) {
        let value = 0;
        title.detections.forEach(x => x.status === 'override' ? value++ : 0);
        return value;
    }

    clickObserve(title: DipDetectionList) {
        if (this.disabled === false) {
            this.step = 'two';
            this.selectedTitle = title.title_name;
            this.selectedContentType = title.content_type;
            this.selectedDetectionList = title.detections;
            this.clickSortTypeStepTwo(this.sortTypeTwo);
        }
    }

    roundValue(value: any) {
        return Math.round(value);
    }

    clickOverride(id: string) {
        if (this.disabled === false) {
            const elementId = 'override-' + id;
            document.getElementById(elementId).style.display = 'flex';
            document.getElementById(elementId).style.width = '139px';
        }
    }

    mouseLeaveOverride(id: string) {
        const elementId = 'override-' + id;
        document.getElementById(elementId).style.display = 'none';
    }
    clickRejectAll(title: DipDetectionList) {
        if (this.disabled === false) {
            this.disabled = true;
            title.detections.forEach(x => x.status = 'rejected');
            this.updateAllDetection(title.detections, 'rejected', title.content_type);
        }
    }

    clickApproveAll(title: DipDetectionList) {
        if (this.disabled === false) {
            this.disabled = true;
            title.detections.forEach(x => x.status = 'accepted');
            this.updateAllDetection(title.detections, 'accepted', title.content_type);
        }
    }

    clickReject(title: DipDetection) {
        if (this.disabled === false) {
            this.disabled = true;
            title.status = 'rejected';
            this.updateDetection(title, this.selectedContentType);
        }

    }

    clickApprove(title: DipDetection) {
        if (this.disabled === false) {
            this.disabled = true;
            title.status = 'accepted';
            this.updateDetection(title, this.selectedContentType);
        }
    }
    clickSaveOverride(id: string, title: DipDetection, value: any) {
        if (this.disabled === false) {
            this.disabled = true;
            const elementId = 'override-' + id;
            document.getElementById(elementId).style.display = 'none';
            if (value !== '') {
                title.status = 'override';
                title.adjusted_value = +value;
                this.updateDetection(title, this.selectedContentType);
            }
        }
    }

    updateDetection(title: DipDetection, contentType) {
        this.dipDetectionService
            .updateDetection(title, contentType)
            .then(res => {
                this.clickSortTypeStepTwo(this.sortTypeTwo);
                this.notificationType = 'success';
                this.notificationTitle = 'Successful';
                this.notificationContent = 'Title : ' + title.pa_content_id + ' state updated succesfully to : ' + title.status;
                this.createNotification();
                this.disabled = false;

            })
            .catch(error => {
                this.errorHandler(error);
                this.selectedSourceList = [];
                const date = new Date();
                date.setDate(date.getDate() - 1);
                this.dateFormatter(date);
                this.getDipDetection(this.dateFormatter(date), this.dateFormatter(date), this.anomalytype);
                this.disabled = false;

            });
    }


    updateAllDetection(title: DipDetection[], status: any, contentType) {
        this.dipDetectionService
            .updateAllDetection(title, status, contentType)
            .then(res => {
                this.clickSortType(this.sortType);
                this.notificationType = 'success';
                this.notificationTitle = 'Successful';
                this.notificationContent = title.length + ' Title states have been succesfully updated to : ' + status;
                this.createNotification();
                this.disabled = false;
            })
            .catch(error => {
                this.errorHandler(error);
                this.selectedSourceList = [];
                const date = new Date();
                date.setDate(date.getDate() - 1);
                this.dateFormatter(date);
                this.getDipDetection(this.dateFormatter(date), this.dateFormatter(date), this.anomalytype);
                this.disabled = false;
            });
    }

    openTitle(titleId: any, contentType) {
        const newWindow = window.open('https://demand360.parrotanalytics.com/' + contentType + '/' + titleId + '/summary');
        return newWindow;
    }

    clickAnomalyType(type: any) {
        this.anomalytype = type;
        this.loading = true;
        this.wikipediaDipDetections = undefined;
        this.bittorentDipDetections = undefined;
        this.facebookDipDetections = undefined;
        this.instagramDipDetections = undefined;
        this.tumblrDipDetection = undefined;
        this.dailymotionDipDetection = undefined;
        this.getDipDetection(this.formattedDate, this.formattedDate, this.anomalytype);
    }

    handleSearchCheckbox(checkboxName) {

        this.loading = true;
        this.wikipediaDipDetections = undefined;
        this.bittorentDipDetections = undefined;
        this.facebookDipDetections = undefined;
        this.instagramDipDetections = undefined;
        this.tumblrDipDetection = undefined;
        this.dailymotionDipDetection = undefined;
        this.checkboxes[checkboxName] = !this.checkboxes[checkboxName];
        this.getDipDetection(this.formattedDate, this.formattedDate, this.anomalytype);
    }
}




// WEBPACK FOOTER //
// ./src/app/catalogue/dipdetection/dipdetection.component.ts